import styles from './styles';

import * as React from 'react';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';

import type HistoryStore from 'connect/web/src/stores/history-store';
import type SearchStore from 'connect/web/src/stores/search-store';
import { SearchType } from 'connect/web/src/stores/search-store';

import Action from './controls/action';

import { withStyles } from '@material-ui/core';

interface IProps extends WithStyles<typeof styles> {
  searchStore?: SearchStore;
  title: string;
  classSubTitle: string;
  classAction: string;
  appointmentSubTitle: string;
  appointmentAction: string;
  showAppointmentAction: boolean;
  showClassAction: boolean;
  historyStore: HistoryStore;
  imageUrl: string;
  useGradient: boolean;
  backgroundColor: string;
}

@inject('historyStore', 'searchStore')
@observer
class Header extends React.Component<IProps> {
  render() {
    const {
      classes,
      showAppointmentAction = false,
      showClassAction = false,
      classSubTitle = 'Browse our classes',
      appointmentSubTitle = 'Browse our appointments',
      classAction = 'Explore Classes',
      appointmentAction = 'Book an Appointment',
      imageUrl,
      searchStore
    } = this.props;
    const { hero, heroContainer, heroContent, image, title } = classes;

    let showAppointmentButton = showAppointmentAction;
    if (showAppointmentAction) {
      showAppointmentButton = searchStore?.hasAppointments ?? false;
    }

    let showClassesButton = showClassAction;
    if (showClassAction) {
      showClassesButton = searchStore?.hasClasses ?? false;
    }

    let imageStyle = {
      backgroundColor: 'transparent',
      background: 'transparent',
      width: '65%'
    };

    if (imageUrl) {
      imageStyle.background = `url('/api/online/files/bypath/${imageUrl}') right center`;
      imageStyle.width = '100%';
    }

    return (
      <div className={hero}>
        <div className={image} style={imageStyle} />
        <div className={this.titleClassName} style={this.gradientStyle}>
          <div className={heroContainer + ' container'}>
            <div className={heroContent}>
              <h1 className={title}>
                {this.titleSgements.map((segment, i) => (
                  <span key={i}>
                    {segment}
                    <br />
                  </span>
                ))}
              </h1>
              {showClassesButton && (
                <Action
                  classes={classes}
                  actionLabel={classAction}
                  mode={SearchType.Class}
                  subTitle={classSubTitle}
                />
              )}
              {showAppointmentButton && (
                <Action
                  classes={classes}
                  actionLabel={appointmentAction}
                  mode={SearchType.Appointment}
                  subTitle={appointmentSubTitle}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  @computed
  private get titleSgements(): string[] {
    const { title = 'Connect Online Bookings' } = this.props;

    return title.split('\n');
  }

  @computed
  private get gradientStyle(): React.CSSProperties {
    const { backgroundColor = '#32B2E7', imageUrl, useGradient = true } = this.props;

    if (useGradient) {
      return {
        background: `linear-gradient(89deg, ${backgroundColor} 35%, rgba(255,255,255,0) 65%)`
      };
    }

    if (!imageUrl && !useGradient) {
      return {
        background: backgroundColor
      };
    }

    return {
      background: 'transparent'
    };
  }

  @computed
  private get titleClassName(): string {
    const { classes, imageUrl, useGradient = true } = this.props;

    const { solid, gradient } = classes;

    if (!useGradient || !imageUrl) {
      return solid;
    }

    return gradient;
  }
}

export default withStyles(styles, { withTheme: true })(Header);
